import {
    DefaultButton, Dropdown, IDropdownOption, MessageBar,
    Pivot, PivotItem, PrimaryButton, ProgressIndicator
} from "@fluentui/react";
import React from "react";
import { defaultButtonStyles, dropdownStyles, primaryButtonStyles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";
import { MenuModel } from "../../models/CategoryModel";
import useNewProductVM from "../../viewmodels/NewProductVM";
import GroupInputView from "./GroupInputView";
import LineInputListView from "./LineInputListView";
import ProductCodeView from "./ProductCodeView";
import ProductInputListView from "./ProductInputListView";

export type NewProductProps = {
    brandOptions: IDropdownOption[];
    sizeOptions: IDropdownOption[];
    categoryList: MenuModel[];
    getSelectedCategoryList: () => MenuModel[];
    onCategoryChecked: (category: MenuModel, checked: boolean) => void;
    onCategoryCollapsed: (category: MenuModel, collapsed: boolean) => void;
    onAction: (refresh: boolean) => void;
}

export default function NewProductView({
    brandOptions, sizeOptions, categoryList, getSelectedCategoryList,
    onCategoryChecked, onCategoryCollapsed, onAction
}: NewProductProps) {
    const vm = useNewProductVM();

    const width5 = Utils.getColumnWidth(5);
    const width7 = Utils.getColumnWidth(7);

    const onSizeChange = (
        event: React.FormEvent<HTMLDivElement>,
        option?: IDropdownOption
    ) => {
        if (!option) return;

        vm.setSizes(prev =>
            option.selected
                ? [...prev, option.key as number]
                : prev.filter(key => key !== option.key)
        );
    };

    const onSubmit = () => {
        vm.submit([]);
    }

    const onPivotClick = (item?: PivotItem) => {
        if (item != null && item.props.headerText === "Products" &&
            window.confirm("Would you like to refresh product list?")) {
            vm.generateProducts();
        }
    }

    const sizePicker = () => {
        return <>
            <Dropdown
                label={"Sizes"}
                multiSelect
                selectedKeys={vm.sizes}
                options={sizeOptions}
                onChange={onSizeChange}
                styles={dropdownStyles}
            />
        </>;
    }

    const groupForm = () => {
        return <div className="box">
            <GroupInputView
                form={vm.groupForm}
                onValueChange={vm.setGroupField}
                brandOptions={brandOptions}
                categoryList={categoryList}
                getSelectedCategoryList={getSelectedCategoryList}
                onCategoryChecked={onCategoryChecked}
                onCategoryCollapsed={onCategoryCollapsed}
            />
        </div>;
    }

    const lineForm = () => {
        return <div className="box">
            <LineInputListView
                lines={vm.lines}
                setLines={vm.setLines}
                onValueChange={vm.updateLineField}
            />
        </div>;
    }

    const inputTab = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row pt-10">
                <div className={width5}>
                    {groupForm()}
                </div>
                <div className={width7}>
                    {lineForm()}

                    <div className="box mt-20 p-15">
                        {sizePicker()}

                        <div className="pt-10">
                            <ProductCodeView codes={vm.codes} setCodes={vm.setCodes} />
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    const productTab = () => {
        return <div className="pt-10 ph-10">
            <div className="center pb-20">
                <DefaultButton
                    onClick={vm.generateProducts}
                    styles={defaultButtonStyles}
                    style={{ width: 150 }}
                >Refresh Products</DefaultButton>
            </div>

            <ProductInputListView
                lines={vm.lines}
                sizeOptions={sizeOptions}
                onValueChange={vm.updateProductField}
            />

            {!vm.submitting && <div className="pv-20 right">
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                    style={{ width: 150 }}
                >Submit</PrimaryButton>
            </div>}

            {vm.submitting && <div className="pt-20">
                <ProgressIndicator label="Submitting" description="" />
            </div>}
        </div>;
    }

    return <>
        {vm.summaryText && <MessageBar messageBarType={vm.summaryType}>{vm.summaryText}</MessageBar>}

        <Pivot onLinkClick={onPivotClick}>
            <PivotItem headerText="Main Info">
                {inputTab()}
            </PivotItem>
            <PivotItem headerText="Products">
                {productTab()}
            </PivotItem>
        </Pivot>
    </>;
}